import LegalPage from "./LegalPage";
export default function Terms() { return <LegalPage endpoint="/legal/terms" title="Terms of Service & Liability Disclaimer" />; }
